module.exports = __webpack_public_path__ + "static/people_img21-d30895c5aee2cd9bec433b19dc155a41.png";